(function() {
  'use strict';

  /**
   * Initialize Maplefair Trust Badge animations
   * @param {HTMLElement} container - The trust badge container
   */
  window.mfTrustInit = function(container) {
    if (!container) return;

    var shimmer = container.querySelector('.mf-trust__shimmer');
    if (shimmer) {
      shimmer.style.animation = 'none';
      void shimmer.offsetHeight;
      shimmer.style.animation = null;
    }
  };

  /**
   * Initialize all trust badges on page
   */
  function initAll() {
    document.querySelectorAll('.mf-trust').forEach(function(el) {
      window.mfTrustInit(el);
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function(event) {
    var trust = event.target.querySelector('.mf-trust');
    if (trust) {
      window.mfTrustInit(trust);
    }
  });
})();


/**
 * Back to Product banner — populate from URL params
 */
(function() {
  'use strict';

  function getQueryParam(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  var returnTo = getQueryParam('return_to');
  var productName = getQueryParam('product_name');
  var productImage = getQueryParam('product_image');

  if (!returnTo) return;

  var banner = document.getElementById('mf-back-banner');
  var link = document.getElementById('mf-back-link');
  var nameEl = document.getElementById('mf-back-product');
  var imgEl = document.getElementById('mf-back-image');

  if (!banner || !link) return;

  link.href = returnTo;

  if (nameEl && productName) {
    nameEl.textContent = productName;
  }

  if (imgEl && productImage) {
    imgEl.src = productImage;
    imgEl.alt = productName || 'Product';
  }

  banner.style.display = 'block';
})();